<template>
  <div class="im-form" ref="form">
    <template v-if="dialog">
      <template v-if="!isGroupDialog && dialog.user.isIgnored">
        Вы игнорируете пользователя
      </template>
      <template v-else-if="!isGroupDialog && dialog.user.isIgnoreMe">
        Пользователь вас игнорирует
      </template>
      <template v-else>
        <template v-if="isGroupDialog">
          <div>Вы пишите массовое сообщение группе: {{ dialog.title }}</div>
          <template v-if="dialog.users.length <= 5">
            <span v-for="(user, index) in dialog.users" :key="index">
              <span>{{ user.name }}</span><span v-if="index + 1 != dialog.users.length">, </span>
            </span>
          </template>
          <div v-else>Всего {{ dialog.users.length }} чел.</div>
        </template>
        <div class="im-form__tools">
          <Smails @insert="insertSmail"/>
          <div class="im-form__tools-item" @click="quote">
            <svg>
              <use xlink:href="#icon-quote"></use>
            </svg>
          </div>
        </div>
        <textarea ref="textarea" class="im-form__textarea" v-model="dialog.form" @change="change" @blur="blur" v-on:keyup.enter.ctrl.exact="send"></textarea>
        <button class="im-form__submit" @click="send">{{ lockSend ? 'Отправка..' : (isGroupDialog ? 'Отправить массовое сообщение' : 'Отправить') }}</button>
        <span>зажмите Ctrl+Enter для отправки</span>
      </template>
    </template>
  </div>
</template>
<script>
  import Smails from './smails/Smails.vue';
  import ADL from "../../ADL";
  const adl = new ADL();

  export default {
    name: 'Form',
    components: {
      Smails
    },
    data() {
      return {
        selectionStart: null,
        lockSend: false
      }
    },
    computed: {
      dialog() {
        return this.$store.state.dialog;
      },
      message() {
        return this.$store.state.dialog.form;
      },
      isGroupDialog() {
        return !!this.dialog.group;
      },
    },
    mounted(){
      const rect = this.$refs.form.getBoundingClientRect();
    },
    methods: {
      change(data) {
        this.$store.dispatch('dialogAddForm', data.target.value);
      },
      blur(e) {
        this.selectionStart = e.target.selectionStart;
      },
      insertSmail(data) {
        const text = this.$refs.textarea.value;
        const leftText = text.substring(0, this.selectionStart);
        const rightText = text.substring(this.selectionStart);
        const resltText = leftText.trim() + ` ${data} ` + rightText.trim();
        this.$store.dispatch('dialogAddForm', resltText);
      },
      quote() {
        let data = this.$store.state.dialog.selectedText;
        if (data !== '') {
          data = `<quote>${data}</quote>`;
          const text = this.$refs.textarea.value;
          const leftText = text.substring(0, this.selectionStart);
          const rightText = text.substring(this.selectionStart);
          const resltText = leftText.trim() + ` ${data} ` + rightText.trim();
          this.$store.dispatch('dialogAddForm', resltText);
        }
      },
      async send(){
        if (this.lockSend) {
          return;
        }

        this.lockSend = true;
        const message = this.$refs.textarea.value;
        const dialog = this.$store.state.dialog;
        const groupId = dialog.group !== null ? dialog.group.id : 0;

        let recipients = [];
        if (groupId) {
          recipients = dialog.users.map(item => item.id);
        } else {
          recipients = [dialog.user.ID];
        }
        try {
          await adl.sendMessage(message, recipients, groupId);
          await this.$store.dispatch('updateMessages');
          this.$store.dispatch('dialogAddForm', "");
          this.lockSend = false;
        } catch (e) {
          alert(e.message);
          this.lockSend = false;
        }
      }
    }
  };
</script>


<style lang="scss">
  .im-form {
    flex-shrink: 0;
    border-top: 1px solid #D6D6D6;
    padding: 20px;

    &__textarea {
      box-sizing: border-box;
      border: 1px solid #D6D6D6;
      width: 100%;
      min-height: 120px;
      resize: vertical;
    }

    &__tools {
      display: flex;
      align-items: center;
      padding: 8px 0;
    }

    &__tools-item {
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 0 8px 0 0;
      width: 36px;
      height: 36px;
      position: relative;

      svg {
        fill: #8D96A1;
        width: 20px;
        height: 20px;
      }
    }

    &__submit {
      background: #1588E2;
      border: 1px solid #D6D6D6;
      border-radius: 2px;
      padding: 12px 24px;
      font-size: 13px;
      line-height: 15px;
      text-align: center;
      color: #FFF;
    }
  }
</style>